import { z } from 'zod/v3';

export const DomDiffDTOSchema = z.object({
  id: z.string(),
  timestamp: z.date(),
  relativeTime: z.number(),
  operations: z.array(z.any()),
  createdAt: z.date(),
  updatedAt: z.date(),
  baseSnapshot: z.string(),
  flow: z.string(),
  workspace: z.string(),
  step: z.string(),
});

export const CreateDomDiffDTOSchema = z.object({
  id: z.string(),
  timestamp: z.date(),
  relativeTime: z.number(),
  operations: z.array(z.any()),
});


export type DomDiffDTO = z.infer<typeof DomDiffDTOSchema>;
export type CreateDomDiffDTO = z.infer<typeof CreateDomDiffDTOSchema>;

